/*
 * File: TaskColumn.tsx
 * Project: a-a
 * File Created: Saturday, 9th November 2024 9:48:20 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 3rd September 2025 8:49:08 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React, { memo, useCallback, useEffect, useState } from 'react';

import Stack from '@mui/material/Stack';
import {
  Badge,
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Typography,
} from '@mui/material';
import zeplinColor from '../../../../../theme/Color';
import InfiniteScrollColumn from '../../../InfiniteScrollColumn/InfiniteScrollColumn';
import { DashboardService } from '../../../../../service/dashboard.service';
import TaskCard from './TaskCard/TaskCard';
import CustomChip from '../../../CustomChip/CustomChip';
import CustomPopOver from '../../../CustomPopOver/CustomPopOver';

import CustomButton from '../../../CustomButton/CustomButton';

// import { AuthService } from '../../../../service/auth.service';
import { LightTooltip } from '../../../CustomTooltip/CustomTooltip';
import { Link, useLocation, useParams } from 'react-router-dom';
import { ClientService } from '../../../../../service/client.service';

import CustomAddTask from '../../../CustomAddTask/CustomAddTask';
import { SFService } from '../../../../../service/SF.service';
import CustomAlert from '../../../CustomAlert/CustomAlert';
import CustomAlertContain from '../../../CustomAlert/CustomAlertContain';
import styles from './TaskColumn.module.css';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
      // padding: '16px',
    },
  },
};

const TaskColumn = ({
  setActiveTab,
  setTabLoading,
  setValue,
}: {
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
  setTabLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setValue?: React.Dispatch<React.SetStateAction<number>> | undefined;
}) => {
  const location = useLocation();
  const code = location?.search?.split('code=')[1];
  const selected = sessionStorage.getItem('sf_edit_selected');
  const IsSlackConnecting = sessionStorage.getItem('slackConnecting') === 'true';
  const calendarConnecting = sessionStorage.getItem('calendar-connecting') === 'true';
  const sf_delete = sessionStorage.getItem('sf_delete') || '';
  const sf_edit = sessionStorage.getItem('sf_edit') || '';
  const sf_redirect = sessionStorage.getItem('sf_redirect') || '';
  const sf_token = sessionStorage.getItem('SFToken') || '';

  let parse_sf = {
    access_token: '',
    id: '',
    instance_url: '',
    issued_at: '',
    refresh_token: '',
    scope: '',
    signature: '',
    token_type: '',
  };
  if (sf_token) {
    parse_sf = JSON.parse(sf_token);
    // parse_sf = sf_token
  }

  const screenHeight = window.innerHeight;
  const user = sessionStorage.getItem('current-user') || '';
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [anchorElTimeRange, setAnchorElTimeRange] = useState<null | HTMLElement>(null);
  const [anchorElTools, setAnchorElTools] = useState<null | HTMLElement>(null);
  const [selectedItems, setSelectedItems] = useState<{
    priority: string[];
    status: string[];
    time: string[];
    client: string[];
    recordTypes: string[];
  }>({
    priority: [],
    status: [],
    time: [],
    client: [],
    recordTypes: [],
  });
  const [clientList, setClientList] = useState([]);

  // const [time, setTime] = React.useState('');
  const [overdueFilter, setOverdueFilter] = useState(false);

  // console.log(showFilter, 'show');

  const [activeChip, setActiveChip] = useState<string[]>([]); // Track if the chip is active

  const handleClickChip = (val: string) => {
    const unique = activeChip.filter((valRef: string) => val === valRef);
    // console.log(unique, activeChip);
    setActiveChip((prev: string[]) =>
      unique?.length ? prev.filter((valRef: string) => val !== valRef) : [...prev, val],
    ); // Toggle the active state on click
  };

  const applyFilter = () => {
    getTask();
    setAnchorEl(null);
  };

  const handleSelection = (item: any, type: string) => {
    const key = type as keyof typeof selectedItems;

    const {
      target: { value },
    } = item;

    setSelectedItems({
      ...selectedItems,
      [key]: typeof value === 'string' ? value.split(',') : value,
    });
  };

  const handleTaskFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOverdueFilter(e.target.checked);
  };

  const handleClearAll = () => {
    setOverdueFilter(false);
    setSelectedItems({
      priority: [],
      status: [],
      time: [],
      client: [],
      recordTypes: [],
    });
    getTask(false, true);
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const params = useParams();
  // const location = useLocation();
  const [data, setData] = useState({
    done: 0,
    totalRecords: 0,
    records: [],
    service: '',
    inProgress: 0,
    todo: 0,
    totalFilteredRecords: 0,
  });
  const [loading, setLoading] = useState(true);
  const [recordTypesOptions, setRecordTypesOptions] = useState(['']);
  const [offset, setOffset] = useState(0);
  const Priority = ['High', 'Normal', 'Low'];

  const TimeRange = ['Day', 'Week', 'Month'];

  // console.log(toDoLoading, inProgressLoading, doneLoading, 'total');
  const [modalOpen, setModalOpen] = React.useState(false);
  const [drawerState, setDrawerState] = React.useState(false);
  const [taskAnchorEl, setTaskAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [alert, setAlert] = React.useState('');
  const [added, setAdded] = React.useState(false);

  const getTask = async (next?: boolean, clear?: boolean) => {
    setLoading(true);
    try {
      const recordTypesQuery = selectedItems.recordTypes
        .map((val) => encodeURIComponent(val))
        .join(',');
      //(val.toLocaleLowerCase() === 'normal' ? 'medium' : val.toLocaleLowerCase()))

      const priorityQuery = selectedItems.priority
        .map((val) => val.toLocaleLowerCase()) //(val.toLocaleLowerCase() === 'normal' ? 'medium' : val.toLocaleLowerCase()))
        .join(',');
      const clientQuery = selectedItems.client.join(',');
      const timeQuery = selectedItems.time
        .map((val: string) =>
          val.toLocaleLowerCase() === 'day' ? 'today' : 'this' + val.toLocaleLowerCase(),
        ) //.toLocaleLowerCase()
        .join(',');

      const overdueQuery = overdueFilter ? `${overdueFilter}` : '';
      const statusQuery = activeChip
        ?.map((val) =>
          val?.toLocaleLowerCase() === 'not started'
            ? 'To Do'
            : val?.toLocaleLowerCase() === 'completed'
            ? 'Done'
            : 'In Progress',
        )
        .join(',');
      const res = params?.id
        ? await ClientService.getTasks(params?.id, {
            // mailId: user,
            priority: clear ? '' : priorityQuery,

            timeRange: clear ? '' : timeQuery,
            isOverdue: clear ? '' : overdueQuery,
            status: clear ? '' : statusQuery,
            limit: 10,
            offset: next ? offset + 10 : 0,
            recordTypes: clear ? '' : recordTypesQuery,
          })
        : await DashboardService.getTasks({
            mailId: user,
            priority: clear ? '' : priorityQuery,
            client: clear ? '' : clientQuery,
            timeRange: clear ? '' : timeQuery,
            isOverdue: clear ? '' : overdueQuery,
            status: clear ? '' : statusQuery,
            limit: 10,
            offset: next ? offset + 10 : 0,
            recordTypes: clear ? '' : recordTypesQuery,
          });

      if (next) {
        setOffset((prev) => prev + 10);
      } else {
        setOffset(0);
      }
      if (res) {
        !next
          ? setData({ ...res, records: [...res.records] })
          : setData({ ...res, records: [...data.records, ...res.records] });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
      setTabLoading(false);
    }
  };

  const getClient = async () => {
    try {
      const res = await DashboardService.getClient();
      // console.log(res);
      setClientList(res?.task_filter_values?.client);
      setRecordTypesOptions(res?.task_filter_values?.recordTypes);
    } catch (err) {
      console.log(err);
    }
  };
  const getSFToken = async () => {
    try {
      const res = await SFService.getSFToken(code);

      if (res.access_token) {
        // localStorage.setItem('sfToken', JSON.stringify(res));
        sessionStorage.setItem('SFToken', JSON.stringify(true));
        window.dispatchEvent(
          new CustomEvent('sessionStorageChange', {
            detail: { key: 'SFToken', value: 'true' },
          }),
        );
        // sessionStorage.setItem('MSToken', JSON.stringify(res.isMSLogin));
      }
    } catch (err) {
      setAlert('Something went wrong while fetching ms events');
    } finally {
      sessionStorage.removeItem('meeting-connecting');
    }
  };
  useEffect(() => {
    if (!drawerState) {
      getTask();
    }
  }, [activeChip?.length, drawerState]);
  useEffect(() => {
    getClient();
    const meetingConnecting = sessionStorage.getItem('meeting-connecting');
    !meetingConnecting && code && !IsSlackConnecting && !calendarConnecting && getSFToken();
  }, [code]);

  useEffect(() => {
    sf_redirect === 'Overview' &&
      // parse_sf?.access_token &&
      sf_token === 'true' &&
      !sf_edit &&
      !sf_delete &&
      !IsSlackConnecting &&
      handleModalOpen();
  }, [sf_redirect, sf_token]);

  const renderTaskCard = (val: any) => <TaskCard data={val} loading={loading} />;

  // console.log(screenHeight);

  const handleTaskCreateClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (sf_token === 'true') {
      setModalOpen(true);
    } else {
      setTaskAnchorEl(event.currentTarget);
    }
  };

  const openTask = Boolean(taskAnchorEl);
  const idTask = openTask ? 'simple-popover' : undefined;

  const handleModalOpen = () => {
    setTaskAnchorEl(null);
    setModalOpen(true);
  };
  const handleModalClose = () => {
    setModalOpen(false);
    sessionStorage.removeItem('sf_redirect');
    sessionStorage.removeItem('sf_path');
  };

  const handleContinueAdd = () => {
    handleModalClose();
    setDrawerState(true);
  };
  const handleRedirect = () => {
    sessionStorage.setItem('sf_redirect', 'Overview');
    sessionStorage.setItem('sf_path', location?.pathname);
  };
  const handleClose = () => {
    // setAlert('');
    setAdded(false);
  };

  // useEffect(() => {
  //   setAlert('Task added');
  // }, [added]);
  // console.log({ added, alert });
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        maxHeight: '100vh',
        overflowY: 'scroll',
        flex: 1,
      }}
    >
      <Box sx={{ position: 'sticky', padding: '10px 0px 0px 0px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '12px',
          }}
        >
          <Typography variant='responsiveHeading3'>
            {params?.id ? '' : 'Your '}Tasks ({data?.totalFilteredRecords})
          </Typography>

          <Box sx={{ display: 'flex', gap: '8px' }}>
            <Badge
              badgeContent={Object.values(selectedItems).reduce(
                (prev, val) => (val?.length ? prev + 1 : prev),
                overdueFilter ? 1 : 0,
              )}
              color='primary'
              sx={{
                '.MuiBadge-badge': {
                  top: { xs: '0.5', xl: '0.7rem' },
                  right: '0.2rem',
                  zIndex: 99,
                  fontSize: { xs: '10px', xl: '12px' },
                },
              }}
              // sx={{
              //   '.MuiBadge-badge': {
              //     top: { xs: '0px', xl: '0px' }, // Reset top positioning
              //     right: { xs: '-4px', xl: '-8px' }, // Move badge more to the right
              //     transform: 'translate(50%, -50%)', // Better positioning
              //     zIndex: 10, // Ensure badge appears above other elements
              //   },
              //   position: 'relative', // Ensure proper positioning context
              //   display: 'flex', // Create proper containing block
              //   marginRight: '8px', // Add right margin to ensure badge has space
              // }}
            >
              <LightTooltip
                title={
                  <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                    Filter
                  </Typography>
                }
                placement='bottom-end'
                style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
                // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
              >
                <Box
                  className={styles.filterBox}
                  sx={{
                    border: `1px solid ${zeplinColor.Neutral6}`,
                    // p: '0px 10px',
                    backgroundColor: loading ? zeplinColor.Neutral3 : zeplinColor.Neutral1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: zeplinColor.Neutral4,
                      // border: `1px solid ${zeplinColor.BasicBlack}`,
                    },
                  }}
                  onClick={(e) => (loading ? '' : handleClick(e))}
                >
                  <img src={'/assets/filter.svg'} className={styles.icon} />
                </Box>
              </LightTooltip>
            </Badge>
            <LightTooltip
              title={
                <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                  New task
                </Typography>
              }
              placement='bottom-end'
              style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
              // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
            >
              <Box
                className={styles.filterBox}
                sx={{
                  border: `1px solid ${zeplinColor.Neutral6}`,
                  // p: '0px 10px',
                  backgroundColor: loading ? zeplinColor.Neutral3 : zeplinColor.Neutral1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: zeplinColor.Neutral4,
                    // border: `1px solid ${zeplinColor.BasicBlack}`,
                  },
                }}
                onClick={handleTaskCreateClick}
              >
                <img src={'/assets/add.svg'} className={styles.icon} />
              </Box>
            </LightTooltip>
          </Box>
          <CustomPopOver
            setAnchorEl={setAnchorEl}
            anchorEl={anchorEl}
            id={id}
            sx={{
              borderRadius: '14px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
              marginTop: '8px',
              marginRight: '2rem',
              marginLeft: '-4rem',
            }}
          >
            <Box
              sx={{
                height: params?.id ? { xs: '20rem', xl: '25rem' } : { xs: '22rem', xl: '27rem' },
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Box
                sx={{
                  padding: '16px',
                  width: { xs: '250px', xl: '283px' },
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '24px',
                  height: '100%',
                  overflow: 'auto',
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                    Filter
                  </Typography>
                  <Typography
                    variant='responsiveButtonSmall'
                    color={
                      Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                        ? zeplinColor.Neutral8
                        : zeplinColor.Brand1
                    }
                    onClick={
                      Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                        ? () => {}
                        : handleClearAll
                    }
                    sx={{
                      cursor:
                        Object.values(selectedItems).every((val) => val.length <= 0) &&
                        !overdueFilter
                          ? 'default'
                          : 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    Clear All
                  </Typography>
                </Box>

                {/* <div> */}
                <FormGroup
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                  }}
                >
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel
                      id='demo-multiple-name-label'
                      sx={{
                        fontSize: { xs: '14px', xl: '16px' },
                        '&.Mui-focused': { color: zeplinColor.Neutral9 },
                      }}
                    >
                      Record Types
                    </InputLabel>
                    <Select
                      labelId='demo-multiple-name-label'
                      id='demo-multiple-name'
                      multiple
                      value={selectedItems.recordTypes}
                      onChange={(e) => handleSelection(e, 'recordTypes')}
                      input={
                        <OutlinedInput
                          sx={{
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderWidth: '1px',
                              color: zeplinColor.Neutral9,
                              borderColor: zeplinColor.Neutral9,
                            },
                            // paddingLeft: '16px',
                            padding: '0px 14px',
                          }}
                          label='Record Types'
                        />
                      }
                      renderValue={(selected) => (selected as string[]).join(', ')}
                      MenuProps={MenuProps}
                      IconComponent={() => (
                        <img src='/assets/down-arrow.svg' className={styles['icon-24']} />
                      )}
                    >
                      {recordTypesOptions.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          sx={{
                            fontSize: { xs: '12px', xl: '16px' }, // Match responsive font size
                            padding: { xs: '6px 16px', xl: '8px 16px' }, // Adjust padding for better appearance
                          }}
                        >
                          <Checkbox
                            checked={selectedItems.recordTypes.indexOf(name) > -1}
                            sx={{
                              color: zeplinColor.BasicBlack,
                              '&.Mui-checked': {
                                color: zeplinColor.BasicBlack,
                              },
                            }}
                          />
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel
                      id='demo-multiple-name-label'
                      sx={{
                        fontSize: { xs: '14px', xl: '16px' },
                        '&.Mui-focused': { color: zeplinColor.Neutral9 },
                      }}
                    >
                      Priority
                    </InputLabel>
                    <Select
                      labelId='demo-multiple-name-label'
                      id='demo-multiple-name'
                      multiple
                      value={selectedItems.priority}
                      onChange={(e) => handleSelection(e, 'priority')}
                      input={
                        <OutlinedInput
                          sx={{
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderWidth: '1px',
                              color: zeplinColor.Neutral9,
                              borderColor: zeplinColor.Neutral9,
                            },
                            // paddingLeft: '16px',
                            padding: '0px 14px',
                          }}
                          label='Priority'
                        />
                      }
                      renderValue={(selected) => (selected as string[]).join(', ')}
                      MenuProps={MenuProps}
                      IconComponent={() => (
                        <img src='/assets/down-arrow.svg' className={styles['icon-24']} />
                      )}
                    >
                      {Priority.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          sx={{
                            fontSize: { xs: '14px', xl: '16px' }, // Match responsive font size
                            padding: { xs: '6px 16px', xl: '8px 16px' }, // Adjust padding for better appearance
                          }}
                        >
                          <Checkbox
                            checked={selectedItems.priority.indexOf(name) > -1}
                            sx={{
                              color: zeplinColor.BasicBlack,
                              '&.Mui-checked': {
                                color: zeplinColor.BasicBlack,
                              },
                            }}
                          />
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {params?.id ? (
                    ''
                  ) : (
                    <FormControl sx={{ width: '100%' }}>
                      <InputLabel
                        id='demo-multiple-name-label'
                        sx={{
                          fontSize: { xs: '14px', xl: '16px' },
                          '&.Mui-focused': { color: zeplinColor.Neutral9 },
                        }}
                      >
                        Client
                      </InputLabel>
                      <Select
                        labelId='demo-multiple-name-label'
                        IconComponent={() => (
                          <img src='/assets/down-arrow.svg' className={styles['icon-24']} />
                        )}
                        id='demo-multiple-name'
                        multiple
                        value={selectedItems.client}
                        onChange={(e) => handleSelection(e, 'client')}
                        input={
                          <OutlinedInput
                            sx={{
                              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderWidth: '1px',
                                color: zeplinColor.Neutral9,
                                borderColor: zeplinColor.Neutral9,
                              },
                              padding: '0px 14px',
                            }}
                            label='Client'
                          />
                        }
                        // IconComponent={() => (
                        //   <img src='/assets/down-arrow.svg' width='24px' height='24px' />
                        // )}
                        renderValue={(selected) => (selected as string[]).join(', ')}
                        MenuProps={MenuProps}
                      >
                        {clientList?.map((name) => (
                          <MenuItem
                            key={name}
                            value={name}
                            sx={{
                              fontSize: { xs: '14px', xl: '16px' }, // Match responsive font size
                              padding: { xs: '6px 16px', xl: '8px 16px' }, // Adjust padding for better appearance
                            }}
                          >
                            <Checkbox
                              checked={selectedItems.client.indexOf(name) > -1}
                              // color={zeplinColor.BasicBlack}
                              sx={{
                                color: zeplinColor.BasicBlack,
                                '&.Mui-checked': {
                                  color: zeplinColor.BasicBlack,
                                },
                              }}
                            />
                            {name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel
                      id='demo-multiple-name-label'
                      sx={{
                        fontSize: { xs: '14px', xl: '16px' },
                        '&.Mui-focused': { color: zeplinColor.Neutral9 },
                      }}
                    >
                      Time range
                    </InputLabel>
                    <Select
                      labelId='demo-multiple-name-label'
                      id='demo-multiple-name'
                      // multiple
                      value={selectedItems.time}
                      onChange={(e) => handleSelection(e, 'time')}
                      input={
                        <OutlinedInput
                          sx={{
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderWidth: '1px',
                              color: zeplinColor.Neutral9,
                              borderColor: zeplinColor.Neutral9,
                            },
                            padding: '0px 14px',
                          }}
                          label='Time range'
                        />
                      }
                      IconComponent={() => (
                        <img src='/assets/down-arrow.svg' className={styles['icon-24']} />
                      )}
                      renderValue={(selected) => selected[0]}
                      MenuProps={MenuProps}
                    >
                      {TimeRange.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          sx={{ fontSize: { xs: '14px', xl: '16px' } }}
                        >
                          <Radio
                            checked={selectedItems.time[0] === name} // Check if this radio should be selected
                            sx={{
                              color: zeplinColor.BasicBlack,
                              '&.Mui-checked': {
                                color: zeplinColor.BasicBlack,
                              },
                              '& .MuiSvgIcon-root': {
                                fontSize: { xs: '18px', xl: '20px' },
                              },
                            }}
                          />
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ width: '100%' }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={overdueFilter}
                          // defaultChecked
                          onChange={handleTaskFilter}
                          sx={{
                            width: '51px', // Track width
                            height: { xs: '28px', xl: '31px' }, // Track height
                            padding: 0, // Remove internal padding for correct thumb alignment
                            '& .MuiSwitch-switchBase': {
                              padding: { xs: '0.6px 0px', xl: '1px 0px ' },
                              // display: 'flex',
                              // justifyContent: 'center',
                              // alignItems: 'center',
                              margin: '2px',
                              transitionDuration: '300ms',
                              '&.Mui-checked': {
                                transform: 'translateX(20px)', // Thumb moves 20px to the right when checked
                                color: zeplinColor.Blue, // Thumb color
                                '& + .MuiSwitch-track': {
                                  backgroundColor: zeplinColor.BasicBlack, // Track color when the switch is on
                                  opacity: 1, // Full opacity when on
                                  border: 0,
                                },
                              },
                              '&.Mui-focusVisible .MuiSwitch-thumb': {
                                color: zeplinColor.Neutral9, // Color for thumb when focused
                                border: '1px solid #fff', // Focus border
                              },
                              '&.Mui-disabled .MuiSwitch-thumb': {
                                color: '#D3D3D3', // Disabled thumb color (light gray)
                              },
                              '&.Mui-disabled + .MuiSwitch-track': {
                                opacity: 0.7, // Track opacity when disabled
                              },
                            },
                            '& .MuiSwitch-thumb': {
                              boxSizing: 'border-box',
                              width: { xs: '23px', xl: '25px' }, // Thumb width
                              height: { xs: '23px', xl: '25px' }, // Thumb height
                              backgroundColor: zeplinColor.Neutral1, // Thumb color
                            },
                            '& .MuiSwitch-track': {
                              borderRadius: '100px', // Border radius for the off state (left side rounded)
                              backgroundColor: zeplinColor.Neutral5, // Track color when off
                              opacity: 0.6, // Track opacity when off
                              transition: 'background-color 300ms ease', // Smooth transition when toggling
                            },
                          }}
                        />
                      }
                      label='Overdue task'
                      labelPlacement='start'
                      sx={{
                        '& .MuiFormControlLabel-label': {
                          fontSize: { xs: '16px', xl: '16px' }, // Apply responsive font size to the label
                        },
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginLeft: 0,
                        width: '100%',
                      }}
                    />
                  </FormControl>
                  <Box sx={{ display: 'flex', alignItems: 'flex-end', flex: 1 }}>
                    <CustomButton
                      onClick={applyFilter}
                      variant='contained'
                      disabled={
                        Object.values(selectedItems).every((val) => val.length <= 0) &&
                        !overdueFilter
                      }
                      color={'primary'}
                      style={{
                        width: '100%',
                        borderRadius: '14px',
                        height: { xs: '48px', md: '56px' },
                      }}
                      textStyle={{
                        color:
                          Object.values(selectedItems).every((val) => val.length <= 0) &&
                          !overdueFilter
                            ? zeplinColor.Neutral8
                            : zeplinColor.Neutral1,
                        fontSize: { xs: '14px', xl: '16px' },
                      }}
                      text={'Apply'}
                    />
                  </Box>
                </FormGroup>
              </Box>
            </Box>
          </CustomPopOver>
          <CustomPopOver
            setAnchorEl={setTaskAnchorEl}
            anchorEl={taskAnchorEl}
            id={idTask}
            sx={{
              borderRadius: '14px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
              marginTop: '8px',
              // marginRight: '2rem',
              // marginLeft: '-4rem',
            }}
          >
            <Box
              sx={{
                // height: { xs: '170px', xl: '202px' },
                width: { xs: '300px', xl: '340px' },
                padding: { xs: '18px', xl: '24px' },
                display: 'flex',
                gap: { xs: '26px', xl: '32px' },
                flexDirection: 'column',
              }}
            >
              <Box
                sx={{ display: 'flex', gap: { xs: '10px', xl: '16px' }, flexDirection: 'column' }}
              >
                <Box sx={{ display: 'flex', gap: '12px', justifyContent: 'space-between' }}>
                  <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                    Authentication Required
                  </Typography>
                  <img
                    src={'/assets/close-icon.svg'}
                    className={styles['icon-24']}
                    alt='close'
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setTaskAnchorEl(null);
                    }}
                  />
                </Box>

                <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                  {/* To create/edit a task, please ensure you're logged in to your Salesforce account. */}
                  You need to be logged into Salesforce to perform this action. Please log in to
                  your Salesforce account.
                </Typography>
              </Box>
              <Link
                // target='_blank'
                // rel='noopener noreferrer'
                to={`https://${process.env.REACT_APP_SALESFORCE_URI}/services/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_SALESFORCE}&redirect_uri=${process.env.REACT_APP_REDIRECT}&response_type=code`}
              >
                <CustomButton
                  disabled={false}
                  onClick={handleRedirect}
                  variant='contained'
                  buttonVariant='responsiveButtonLarge'
                  color={'primary'}
                  style={{
                    width: { xs: '125px', xl: '155px' },
                    borderRadius: { xs: '12px', xl: '14px' },
                    height: { xs: '38px', xl: '48px' },
                    padding: '14px 16px',
                    '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                  }}
                  textStyle={{ color: zeplinColor.Neutral1 }}
                  text={'Open Salesforce'}
                  // tabindex={4}
                />
              </Link>
            </Box>
          </CustomPopOver>
        </Box>
        {data?.totalRecords > 0 && (
          <Stack direction='row' spacing={1} sx={{ overflowX: 'auto' }}>
            <CustomChip
              variant='responsiveBody3'
              handleClick={handleClickChip}
              active={activeChip}
              text='To Do'
              count={data?.todo}
              value='not started'
              style={{ borderRadius: '50px', height: { xs: '32px', xl: '40px' } }}
            />
            <CustomChip
              variant='responsiveBody3'
              handleClick={handleClickChip}
              active={activeChip}
              text='In Progress'
              count={data?.inProgress}
              value={'in progress'}
              style={{ borderRadius: '50px', height: { xs: '32px', xl: '40px' } }}
            />
            <CustomChip
              variant='responsiveBody3'
              handleClick={handleClickChip}
              active={activeChip}
              text='Done'
              count={data?.done}
              value={'completed'}
              style={{ borderRadius: '50px', height: { xs: '32px', xl: '40px' } }}
            />
          </Stack>
        )}
      </Box>
      {/* <InfiniteScrollColumn content={<Column />} dataVal={data} /> */}

      {data?.totalFilteredRecords <= 0 && !loading ? (
        <Box sx={{ height: 'calc(100vh-450px)', flex: 1 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',

              alignItems: 'center',
              height: '50%',
              // margin: 'auto',
              // flex: 1,
              // height:
              //   screenHeight > 1200
              //     ? '54vh'
              //     : screenHeight > 1100
              //     ? '52vh'
              //     : screenHeight > 1000
              //     ? '49vh'
              //     : screenHeight > 900
              //     ? '43vh'
              //     : screenHeight > 800
              //     ? '36vh'
              //     : screenHeight > 700
              //     ? '28vh'
              //     : screenHeight > 600
              //     ? '15vh'
              //     : '10vh',
            }}
          >
            {' '}
            <img src={'/assets/no-tasks.svg'} className={styles['no-tasks-icon']} />
            <Typography
              variant='responsiveHeading3'
              color={zeplinColor.BasicBlack}
              sx={{ marginTop: { xs: '22px', xl: '24px' } }}
            >
              No Tasks Yet
            </Typography>
            <Typography
              variant='responsiveBody3'
              color={zeplinColor.Neutral8}
              sx={{ width: '70%', textAlign: 'center', marginTop: { xs: '10px', xl: '12px' } }}
            >
              Looks like there's nothing left to do. New task will appear here once added.
            </Typography>
          </Box>
        </Box>
      ) : loading ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            // flex: 1,
            alignItems: 'center',
            gap: '16px',
            overflowY: 'hidden',
            // height: '100vh',
            // screenHeight > 1200
            //   ? '54vh'
            //   : screenHeight > 1100
            //   ? '52vh'
            //   : screenHeight > 1000
            //   ? '49vh'
            //   : screenHeight > 900
            //   ? '43vh'
            //   : screenHeight > 800
            //   ? '36vh'
            //   : screenHeight > 700
            //   ? '28vh'
            //   : screenHeight > 600
            //   ? '15vh'
            //   : '10vh',
            height: { xs: 'calc(100vh - 415px)', xl: 'calc(100vh - 510px)' },
          }}
        >
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((val: any, ind: number) => (
            <TaskCard data={val} loading={true} key={ind} />
          ))}
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            // flex: 1,
            alignItems: 'center',
            gap: '16px',
            overflowY: 'auto',
            // height: '100vh',
            // screenHeight > 1200
            //   ? '54vh'
            //   : screenHeight > 1100
            //   ? '52vh'
            //   : screenHeight > 1000
            //   ? '49vh'
            //   : screenHeight > 900
            //   ? '43vh'
            //   : screenHeight > 800
            //   ? '36vh'
            //   : screenHeight > 700
            //   ? '28vh'
            //   : screenHeight > 600
            //   ? '15vh'
            //   : '10vh',
            height: { xs: 'calc(100vh - 415px)', xl: 'calc(100vh - 510px)' },
          }}
        >
          {/* <InfiniteScrollColumn
            dataVal={data}
            render={renderTaskCard}
            height={screenHeight > 640 ? '39vh' : '37vh'}
            next={(offset) => getTask(offset)}
            total={data?.totalFilteredRecords}
          /> */}
          <Box
            className={styles['task-column']}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              flex: 1,
              width: '100%',

              overflow: 'auto',
              // paddingBottom: '30rem',
              // maxHeight: 'calc(100vh-300px)',
            }}
          >
            {data?.records.map((val: any, ind: number) => (
              <TaskCard
                data={val}
                loading={loading}
                key={ind}
                options={true}
                getTask={getTask}
                setAlert={setAlert}
                setValue={setValue ? setValue : undefined}
              />
            ))}
            {data?.records?.length ? (
              <CustomButton
                disabled={false}
                onClick={() => {
                  setActiveTab(2);
                }}
                variant='outlined'
                color='secondary'
                style={{
                  // width: '30%',
                  borderRadius: 50,
                  height: 32,
                  textAlign: 'center',
                  gap: '16px',
                }}
                textStyle={{ color: zeplinColor.BasicBlack }}
                text={'See All'}
                icon={''}
                buttonVariant='buttonSmall'
              />
            ) : (
              ''
            )}
          </Box>
        </Box>
      )}

      {(modalOpen || drawerState) && (
        <CustomAddTask
          handleContinueAdd={handleContinueAdd}
          handleModalClose={handleModalClose}
          modalOpen={modalOpen}
          setDrawerState={setDrawerState}
          drawerState={drawerState}
          setAdded={setAdded}
        />
      )}
      <CustomAlert
        open={added || alert ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alert={added ? 'Task added' : alert ? alert : ''}
            alertIcon={
              (alert && alert?.includes('successfully')) || added ? (
                <img src='/assets/checkmark-green.png' width={24} height={24} />
              ) : (
                <img src='/assets/error.svg' width={24} height={24} />
              )
            }
            error={(alert && alert?.includes('successfully')) || added ? false : true}
          />
        }
        error={(alert && alert?.includes('successfully')) || added ? false : true}
      />
    </Box>
  );
};

export default TaskColumn;
